import styled from '@emotion/styled';
import { colors, spacing, borderRadius, typography } from '../tokens';

export type BaseItemStatus = 'pending' | 'complete' | 'error';

export const ItemRoot = styled.button<{ $selected: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${spacing.sm};
  padding: ${spacing.md};
  border-radius: ${borderRadius.lg};
  border: ${({ $selected }) =>
    $selected ? `2px solid ${colors.primary}` : `1px solid ${colors.border}`};
  background: ${colors.neutralBg};
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: ${({ $selected }) =>
      $selected ? colors.primary : colors.borderDark};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const StatusWrap = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing.sm};
`;

export const Infos = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
`;

export const BaseName = styled.span<{ $selected: boolean }>`
  font-family: ${typography.fontFamily.primary};
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${({ $selected }) =>
    $selected ? colors.primary : colors.textContrast};
`;

export const Address = styled.span`
  font-family: ${typography.fontFamily.primary};
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: ${colors.textSecondary};
`;
